
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.25 4H5.75A1.752 1.752 0 0 0 4 5.75v20.5A1.752 1.752 0 0 0 5.75 28h20.5A1.752 1.752 0 0 0 28 26.25V5.75A1.752 1.752 0 0 0 26.25 4Zm.25 1.75v9.5h-3.629L16.75 9.129V5.5h9.5a.25.25 0 0 1 .25.25ZM16 21.5 10.5 16l5.5-5.5 5.5 5.5-5.5 5.5ZM5.75 5.5h9.5v3.629L9.129 15.25H5.5v-9.5a.25.25 0 0 1 .25-.25Zm0 21a.25.25 0 0 1-.25-.25v-9.5h3.629l6.121 6.121V26.5h-9.5Zm20.5 0h-9.5v-3.629l6.121-6.121H26.5v9.5a.25.25 0 0 1-.25.25Z"}})])
          )
        }
      }
    